<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "#bcbfc3";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 32.999 32.999">
	<g>
		<path
			d="M484.09 414.568a16.5 16.5 0 1 0 16.5 16.5 16.5 16.5 0 0 0-16.5-16.5zm0 31.679a15.107 15.107 0 0 1-10.461-4.2l.033-.033 5.121-5.135h-1.861l-4.191 4.2-.02.02a15.168 15.168 0 0 1 21.41-21.41 1.358 1.358 0 0 0-.218.178l-5.379 5.392h1.855l4.455-4.461a1.041 1.041 0 0 0 .191-.238 15.165 15.165 0 0 1-10.936 25.686z"
			transform="translate(-467.591 -414.568)"
			fill={fill} />
		<path
			d="M482 433.328h-6.283v1.386H478v7.18h1.723v-7.18H482z"
			transform="translate(-470.355 -421.105)"
			fill={fill}
			stroke={fill}
			style="stroke-width:.2px" />
		<path
			d="m490.672 435.361-.739-2.053h-2l-2.693 7.492-.389 1.089h1.808l.341-.989.224-.647h3.412l.568 1.63h1.815l-1.855-5.154zm-2.983 3.524.284-.825.957-2.765.462 1.346.482 1.386.3.858z"
			transform="translate(-473.46 -421.098)"
			fill={fill}
			stroke={fill}
			style="stroke-width:.2px" />
		<path
			d="m502.773 437.637 2.686-4.31h-1.934l-1.67 2.871-1.855-2.87h-1.98l.4.621 2.336 3.63-2.7 4.316H500l1.683-2.884 1.848 2.884h1.98z"
			transform="translate(-477.938 -421.105)"
			fill={fill}
			stroke={fill}
			style="stroke-width:.2px" />
	</g>
</svg>

<style lang="scss">
</style>
